/** Default cash party used for havala and ledger. Not valid on game soda. */
export const CASH_PARTY_CODE = 'CAS';
export const CASH_PARTY_ID = 1;

export function isCashParty(party: { id?: number | string; partyCode?: string } | null | undefined): boolean {
  if (!party) return false;
  const id = Number(party.id);
  if (id === CASH_PARTY_ID) return true;
  return (party.partyCode || '').trim().toUpperCase() === CASH_PARTY_CODE;
}

export function isCashPartyCode(code: string | null | undefined): boolean {
  const match = (code || '').trim().match(/^([A-Z0-9]+)/i);
  const partyCode = (match ? match[1] : code || '').trim().toUpperCase();
  return partyCode === CASH_PARTY_CODE;
}
